<template>
  <el-dialog
    top="20vh"
    class="edit-dialog"
    title="取值范围"
    width="700px"
    :before-close="close"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
  >
    <div>
      <el-input-number
        size="small"
        style="width:250px;margin: 0 8px"
        v-model="bounds.min"
        :max="bounds.max"
        placeholder="最小值"
      ></el-input-number>
      <span>~</span>
      <el-input-number
        size="small"
        style="width:250px;margin: 0 8px"
        v-model="bounds.max"
        :min="bounds.min"
        placeholder="最大值"
      ></el-input-number>
    </div>
    <div slot="footer" class="edit-footer">
      <el-button size="small" @click="close">取消</el-button>
      <el-button type="primary" size="small" @click="save">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: () => ({
        min: "",
        max: ""
      })
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      bounds: {
        min: "",
        max: ""
      }
    };
  },
  created() {
    this.bounds = this.row;
  },
  methods: {
    close() {
      this.$emit("update:visible", false);
    },
    save() {
      this.$emit("set", this.bounds);
      this.close();
    }
  }
};
</script>
<style lang="less">

</style>
